import Axios from 'axios'
import config from '../app.config'

export var userService
export default userService = {
	getUsers,
	getUser,
	updateUser,
	createUser,
	deleteUsers,
	resetPassword,
	getListUserSelect,
	getListUserForTelephone,
	updateDisplayOrder
}

async function getUsers(payload) {
	return await Axios.get(`${config.LOCAL_API_URL}/user`, { params: payload })
		.then((response) => {
			if (response.data.success || response.data.status) return Promise.resolve(response.data)
			else return Promise.reject(response.data)
		})
		.catch((error) => {
			return Promise.reject(error)
		})
}
async function getUser(id) {
	return await Axios.get(`${config.LOCAL_API_URL}/user/` + id)
		.then((response) => {
			if (response.data.success || response.data.status) return Promise.resolve(response.data)
			else return Promise.reject(response.data)
		})
		.catch((error) => {
			return Promise.reject(error.response.data)
		})
}
async function updateUser(data) {
	return await Axios.put(`${config.LOCAL_API_URL}/user/` + data.id, data)
		.then((response) => {
			if (response.data.success || response.data.status) return Promise.resolve(response.data)
			else return Promise.reject(response.data)
		})
		.catch((error) => {
			return Promise.reject(error.response.data)
		})
}
async function deleteUsers(params) {
	return await Axios.delete(`${config.LOCAL_API_URL}/user`, { data: params })
		.then((response) => {
			if (response.data.success || response.data.status) return Promise.resolve(response.data)
			else return Promise.reject(response.data)
		})
		.catch((error) => {
			return Promise.reject(error.response.data)
		})
}
async function createUser(params) {
	return await Axios.post(`${config.LOCAL_API_URL}/user`, params)
		.then((response) => {
			if (response.data.success || response.data.status) return Promise.resolve(response.data)
			else return Promise.reject(response.data)
		})
		.catch((error) => {
			return Promise.reject(error.response.data)
		})
}
async function resetPassword(ids) {
	return await Axios.post(`${config.LOCAL_API_URL}/ajax/setting-user/resetpass`, ids)
		.then((response) => {
			if (response.data.success || response.data.status) return Promise.resolve(response.data)
			else return Promise.reject(response.data)
		})
		.catch((error) => {
			return Promise.reject(error.response.data)
		})
}
async function getListUserSelect(data) {
	return await Axios.get(`${config.LOCAL_API_URL}/getListUserSelect`, { params: data })
		.then((response) => {
			if (response.data) {
				return Promise.resolve(response.data)
			} else {
				return Promise.reject(response)
			}
		})
		.catch((error) => {
			return Promise.reject(error)
		})
}
async function getListUserForTelephone() {
	return await Axios.get(`${config.LOCAL_API_URL}/getListUserForTelephone`)
		.then((response) => {
			if (response.data) {
				return Promise.resolve(response.data)
			} else {
				return Promise.reject(response)
			}
		})
		.catch((error) => {
			return Promise.reject(error)
		})
}
async function updateDisplayOrder(data) {
	return await Axios.post(`${config.LOCAL_API_URL}/updateDisplayOrder`, data)
		.then((response) => {
			if (response.data) {
				return Promise.resolve(response.data)
			} else {
				return Promise.reject(response)
			}
		})
		.catch((error) => {
			return Promise.reject(error)
		})
}
